module.exports = __webpack_public_path__ + "img/partly-cloudy-day.3237f7da.svg";